"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var typographyCSS = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.textAlign != null ? "text-align: ".concat(props.textAlign, ";") : '';
}, function (props) {
  // If a string
  // 1) Try pulling from theme
  if (typeof props.color === 'string' && props.theme.colors[props.color] != null) {
    return "color: ".concat(props.theme.colors[props.color][props.colorVariant || 500], ";");
  } // 2) Or just set the value


  if (typeof props.color === 'string') {
    return "color: ".concat(props.color, ";");
  } // Otherwise default to Gray


  return "color: ".concat(props.theme.colors.gray['500'], ";");
}, function (props) {
  return props.opacity ? "opacity: ".concat(props.opacity, ";") : '';
});
var _default = typographyCSS;
exports["default"] = _default;